module.exports = __webpack_public_path__ + "static/img/logo74.b6522f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo74.png
// module id = 9eKM
// module chunks = 1